module.exports = __webpack_public_path__ + "static/media/checkbox-unchecked.57eecb8d.svg";